// import { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import {
//   Button,
//   Checkbox,
//   Col,
//   Form,
//   Input,
//   InputNumber,
//   message,
//   Popconfirm,
//   Row,
//   Table,
//   Tag,
//   Tooltip,
// } from "antd";
// import {
//   CloseCircleOutlined,
//   DeleteOutlined,
//   EditOutlined,
//   FormOutlined,
//   PlusCircleOutlined,
//   ReloadOutlined,
//   SaveOutlined,
//   SearchOutlined,
//   ShoppingCartOutlined,
//   UnorderedListOutlined,
//   NumberOutlined,
//   PercentageOutlined,
//   TagOutlined,
// } from "@ant-design/icons";
// import { CREATE_jwel } from "../../Config/Config";

// const tenantName = localStorage.getItem("tenantName");

// /* ─── palette ───────────────────────────────────────────── */
// const PURPLE = "#7c3aed";
// const INDIGO = "#4f46e5";
// const TEAL = "#0d9488";
// const AMBER = "#d97706";
// const ROSE = "#e11d48";
// const EMERALD = "#059669";
// const SKY = "#0284c7";
// const ORANGE = "#ea580c";

// /* ─── shared styles ─────────────────────────────────────── */
// const G = {
//   page: {
//     background: "linear-gradient(135deg,#f5f3ff 0%,#eff6ff 40%,#ecfdf5 100%)",
//     minHeight: "calc(100vh - 105px)",
//     padding: "20px 24px",
//   },
//   headerBar: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     flexWrap: "wrap",
//     gap: 12,
//     marginBottom: 16,
//   },
//   headerLeft: { display: "flex", alignItems: "center", gap: 14 },
//   headerIcon: {
//     width: 52,
//     height: 52,
//     borderRadius: 14,
//     background: `linear-gradient(135deg,${ORANGE} 0%,${AMBER} 100%)`,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: 26,
//     color: "#fff",
//     boxShadow: `0 6px 18px ${ORANGE}55`,
//   },
//   headerTitle: {
//     margin: 0,
//     fontSize: 22,
//     fontWeight: 800,
//     background: `linear-gradient(90deg,${ORANGE},${AMBER})`,
//     WebkitBackgroundClip: "text",
//     WebkitTextFillColor: "transparent",
//     letterSpacing: 0.3,
//   },
//   headerSub: { margin: 0, fontSize: 13, color: "#64748b", marginTop: 2 },
//   statsRow: { display: "flex", gap: 12, flexWrap: "wrap" },
//   stat: (color) => ({
//     background: "#fff",
//     borderRadius: 12,
//     padding: "10px 18px",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     boxShadow: "0 2px 10px rgba(0,0,0,0.07)",
//     borderTop: `3px solid ${color}`,
//     minWidth: 80,
//   }),
//   statNum: (color) => ({
//     fontSize: 22,
//     fontWeight: 800,
//     color,
//     lineHeight: 1.1,
//   }),
//   statLabel: {
//     fontSize: 11,
//     color: "#94a3b8",
//     fontWeight: 600,
//     marginTop: 2,
//     textTransform: "uppercase",
//     letterSpacing: 0.5,
//   },
//   card: {
//     background: "#fff",
//     borderRadius: 18,
//     boxShadow: "0 4px 28px rgba(0,0,0,0.09)",
//     overflow: "hidden",
//   },
//   panelHead: (from, to) => ({
//     background: `linear-gradient(120deg,${from} 0%,${to} 100%)`,
//     padding: "14px 20px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     gap: 12,
//   }),
//   panelTitle: {
//     display: "flex",
//     alignItems: "center",
//     gap: 8,
//     color: "#fff",
//     fontWeight: 700,
//     fontSize: 14,
//     letterSpacing: 0.4,
//     textTransform: "uppercase",
//   },
//   panelBody: { padding: "22px 22px 18px" },
//   inputStyle: { height: 38, borderRadius: 10, fontSize: 13 },
//   numStyle: { width: "100%", height: 38, borderRadius: 10, fontSize: 13 },
//   sectionLabel: (color) => ({
//     display: "flex",
//     alignItems: "center",
//     gap: 7,
//     fontSize: 11,
//     fontWeight: 700,
//     color,
//     textTransform: "uppercase",
//     letterSpacing: 0.8,
//     marginBottom: 10,
//     marginTop: 4,
//   }),
//   dot: (color) => ({
//     width: 8,
//     height: 8,
//     borderRadius: "50%",
//     background: color,
//     flexShrink: 0,
//   }),
//   hint: {
//     background: "#f8fafc",
//     border: "1px dashed #cbd5e1",
//     borderRadius: 10,
//     padding: "10px 14px",
//     fontSize: 12,
//     color: "#94a3b8",
//     display: "flex",
//     alignItems: "center",
//     gap: 8,
//     marginBottom: 16,
//   },
//   selectedBadge: (color) => ({
//     background: `${color}18`,
//     border: `1px solid ${color}44`,
//     borderRadius: 10,
//     padding: "8px 14px",
//     display: "flex",
//     alignItems: "center",
//     gap: 10,
//     marginBottom: 16,
//   }),
//   badgeAvatar: (color) => ({
//     width: 36,
//     height: 36,
//     borderRadius: 10,
//     background: `linear-gradient(135deg,${color} 0%,${color}99 100%)`,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     color: "#fff",
//     fontSize: 18,
//     flexShrink: 0,
//   }),
//   gstBox: {
//     background: "linear-gradient(135deg,#f0fdf4 0%,#ecfdf5 100%)",
//     border: "1px solid #bbf7d0",
//     borderRadius: 12,
//     padding: "14px 16px",
//     marginBottom: 10,
//   },
//   defaultGstBox: {
//     background: "linear-gradient(135deg,#fefce8 0%,#fef9c3 100%)",
//     border: "1px solid #fde68a",
//     borderRadius: 12,
//     padding: "12px 16px",
//     marginBottom: 14,
//   },
//   gridLabel: {
//     fontSize: 11,
//     fontWeight: 700,
//     color: TEAL,
//     textTransform: "uppercase",
//     letterSpacing: 0.6,
//     marginBottom: 4,
//   },
// };

// const ROW_COLORS = [ORANGE, SKY, TEAL, EMERALD, AMBER, ROSE, INDIGO, PURPLE];

// /* ════════════════════════════════════════════════════════════ */
// export default function PurchaseTypeMaster() {
//   const [form] = Form.useForm();
//   const [tableData, setTableData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [editingKey, setEditingKey] = useState(null);
//   const [filter, setFilter] = useState("");
//   const [allowGst, setAllowGst] = useState(false);
//   const [defaultGst, setDefaultGst] = useState(false);

//   const pTypeRef = useRef(null);

//   /* ── fetch ──────────────────────────────────────────────── */
//   const fetchData = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(
//         `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName`,
//         { params: { tableName: "purchase_type" }, headers: { tenantName } },
//       );
//       const rows = (res.data || []).map((item, idx) => ({
//         key: idx,
//         pType: item.PType ?? item.pType ?? "-",
//         discount: item.Discount ?? item.discount ?? 0,
//         vatper: item.VATPER ?? item.vatper ?? 0,
//         pCode: item.PCode ?? item.pCode ?? "-",
//         pno: item.PNO ?? item.pno ?? 0,
//         bellowvalue: item.BELLOWVALUE ?? item.bellowvalue ?? 0,
//         bellowper: item.BELLOWPER ?? item.bellowper ?? 0,
//         abovevalue: item.ABOVEVALUE ?? item.abovevalue ?? 0,
//         aboveper: item.ABOVEPER ?? item.aboveper ?? 0,
//         allowgstvalue: item.ALLOWGSTVALUE ?? item.allowgstvalue ?? false,
//         effecttopurchases:
//           item.EFFECTTOPURCHASES ?? item.effecttopurchases ?? false,
//         allowtaans: item.ALLOWTAANS ?? item.allowtaans ?? false,
//         bellowvalue_purch:
//           item.BELLOWVALUE_PURCH ?? item.bellowvalue_purch ?? 0,
//         abovevalue_purch: item.ABOVEVALUE_PURCH ?? item.abovevalue_purch ?? 0,
//         defaultgstvale: item.DEFAULTGSTVALE ?? item.defaultgstvale ?? false,
//         defaultgstper: item.DEFAULTGSTPER ?? item.defaultgstper ?? 0,
//       }));
//       setTableData(rows);
//     } catch {
//       message.error("Failed to load purchase type data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//     setTimeout(() => pTypeRef.current?.focus(), 300);
//   }, []); // eslint-disable-line react-hooks/exhaustive-deps

//   /* ── derived ────────────────────────────────────────────── */
//   const q = filter.trim().toLowerCase();
//   const filteredData = q
//     ? tableData.filter(
//         (r) =>
//           r.pType?.toLowerCase().includes(q) ||
//           r.pCode?.toLowerCase().includes(q),
//       )
//     : tableData;

//   const editingRecord =
//     editingKey != null ? tableData.find((r) => r.key === editingKey) : null;

//   /* ── handlers ───────────────────────────────────────────── */

//   // Allow GST and Default GST are mutually exclusive.
//   const handleAllowGstChange = (e) => {
//     const checked = e.target.checked;
//     setAllowGst(checked);
//     if (checked) {
//       setDefaultGst(false);
//       form.setFieldsValue({ defaultgstvale: false, defaultgstper: 0 });
//     }
//   };

//   const handleDefaultGstChange = (e) => {
//     const checked = e.target.checked;
//     setDefaultGst(checked);
//     if (checked) {
//       setAllowGst(false);
//       form.setFieldsValue({
//         allowgstvalue: false,
//         bellowvalue: 0,
//         bellowper: 0,
//         abovevalue: 0,
//         aboveper: 0,
//       });
//     } else {
//       form.setFieldsValue({ defaultgstper: 0 });
//     }
//   };

//   const handleEdit = (record) => {
//     // If legacy data has both flags on, Allow GST wins.
//     const isAllow = !!record.allowgstvalue;
//     const isDefault = !isAllow && !!record.defaultgstvale;

//     setEditingKey(record.key);
//     setAllowGst(isAllow);
//     setDefaultGst(isDefault);
//     form.setFieldsValue({
//       pType: record.pType === "-" ? "" : record.pType,
//       pCode: record.pCode === "-" ? "" : record.pCode,
//       pno: record.pno,
//       discount: record.discount,
//       vatper: record.vatper,
//       allowgstvalue: isAllow,
//       bellowvalue: record.bellowvalue,
//       bellowper: record.bellowper,
//       abovevalue: record.abovevalue,
//       aboveper: record.aboveper,
//       effecttopurchases: !!record.effecttopurchases,
//       allowtaans: !!record.allowtaans,
//       defaultgstvale: isDefault,
//       defaultgstper: isDefault ? (record.defaultgstper ?? 0) : 0,
//     });
//     setTimeout(() => pTypeRef.current?.focus(), 100);
//   };

//   const handleCancel = () => {
//     form.resetFields();
//     setEditingKey(null);
//     setAllowGst(false);
//     setDefaultGst(false);
//     setFilter("");
//     setTimeout(() => pTypeRef.current?.focus(), 100);
//   };

//   const handleRefresh = () => {
//     handleCancel();
//     fetchData();
//     setTimeout(() => pTypeRef.current?.focus(), 300);
//   };

//   // Enter moves focus to the next field instead of submitting the form.
//   // On the last field it lands on the Save button; Enter there submits.
//   const handleFormKeyDown = (e) => {
//     if (e.key !== "Enter" || e.target.tagName !== "INPUT") return;
//     e.preventDefault();
//     const focusables = Array.from(
//       e.currentTarget.querySelectorAll(
//         'input:not([disabled]):not([type="hidden"]), button[type="submit"]',
//       ),
//     ).filter((el) => el.offsetParent !== null);
//     const idx = focusables.indexOf(e.target);
//     const next = focusables[idx + 1];
//     if (next) {
//       next.focus();
//       next.select?.();
//     }
//   };

//   const handleSubmit = async (values) => {
//     setSaving(true);
//     try {
//       // Only one of the two GST modes can be saved.
//       const useAllow = !!values.allowgstvalue;
//       const useDefault = !useAllow && !!values.defaultgstvale;

//       const payload = {
//         pType: (values.pType || "").trim().toUpperCase(),
//         discount: values.discount ?? 0,
//         vatper: values.vatper ?? 0,
//         pCode: (values.pCode || "").trim().toUpperCase(),
//         pno: values.pno ?? 0,
//         bellowvalue: useAllow ? (values.bellowvalue ?? 0) : 0,
//         bellowper: useAllow ? (values.bellowper ?? 0) : 0,
//         abovevalue: useAllow ? (values.abovevalue ?? 0) : 0,
//         aboveper: useAllow ? (values.aboveper ?? 0) : 0,
//         allowgstvalue: useAllow,
//         effecttopurchases: !!values.effecttopurchases,
//         allowtaans: !!values.allowtaans,
//         // Fields removed from the UI: keep existing values when editing, else 0
//         bellowvalue_purch: editingRecord?.bellowvalue_purch ?? 0,
//         abovevalue_purch: editingRecord?.abovevalue_purch ?? 0,
//         defaultgstvale: useDefault,
//         defaultgstper: useDefault ? (values.defaultgstper ?? 0) : 0,
//       };

//       await axios.post(`${CREATE_jwel}/api/Master/PurchaseType`, [payload], {
//         headers: { tenantName },
//       });

//       message.success(
//         editingKey != null ? "Purchase type updated" : "Purchase type added",
//         2,
//       );
//       handleCancel();
//       fetchData();
//     } catch (err) {
//       message.error(err?.response?.data?.message || "Failed to save");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleDelete = async (record) => {
//     try {
//       const safeName = String(record.pType).replace(/'/g, "''");
//       await axios.post(
//         `${CREATE_jwel}/api/ERP/DeleteDataFromGivenTableNameWithWhere?tableName=purchase_type&where=${encodeURIComponent(`PTYPE='${safeName}'`)}`,
//         {},
//         { headers: { tenantName } },
//       );
//       message.success("Purchase type deleted");
//       if (editingKey === record.key) handleCancel();
//       fetchData();
//     } catch {
//       message.error("Delete failed");
//     }
//   };

//   /* ── table columns ──────────────────────────────────────── */
//   const columns = [
//     {
//       title: "#",
//       width: 52,
//       align: "center",
//       render: (_, __, idx) => {
//         const color = ROW_COLORS[idx % ROW_COLORS.length];
//         return (
//           <span
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               justifyContent: "center",
//               width: 28,
//               height: 28,
//               borderRadius: 8,
//               background: `${color}18`,
//               color,
//               fontWeight: 700,
//               fontSize: 12,
//             }}
//           >
//             {idx + 1}
//           </span>
//         );
//       },
//     },
//     {
//       title: (
//         <span
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 5,
//             color: ORANGE,
//           }}
//         >
//           <TagOutlined /> Purchase Type
//         </span>
//       ),
//       dataIndex: "pType",
//       render: (v) => (
//         <span style={{ fontWeight: 700, color: "#1e293b", fontSize: 13 }}>
//           {v}
//         </span>
//       ),
//     },
//     {
//       title: (
//         <span
//           style={{ display: "flex", alignItems: "center", gap: 5, color: SKY }}
//         >
//           <NumberOutlined /> Code
//         </span>
//       ),
//       dataIndex: "pCode",
//       width: 90,
//       render: (v) =>
//         v && v !== "-" ? (
//           <Tag
//             style={{
//               background: `${SKY}15`,
//               color: SKY,
//               border: `1px solid ${SKY}44`,
//               borderRadius: 6,
//               fontWeight: 600,
//               fontSize: 12,
//             }}
//           >
//             {v}
//           </Tag>
//         ) : (
//           <span style={{ color: "#cbd5e1", fontSize: 12 }}>—</span>
//         ),
//     },
//     {
//       title: (
//         <span
//           style={{ display: "flex", alignItems: "center", gap: 5, color: TEAL }}
//         >
//           <PercentageOutlined /> VAT %
//         </span>
//       ),
//       dataIndex: "vatper",
//       width: 80,
//       align: "center",
//       render: (v) => (
//         <Tag
//           style={{
//             background: `${TEAL}12`,
//             color: TEAL,
//             border: `1px solid ${TEAL}33`,
//             borderRadius: 6,
//             fontWeight: 600,
//             fontSize: 12,
//           }}
//         >
//           {v ?? 0}%
//         </Tag>
//       ),
//     },
//     {
//       title: "GST",
//       dataIndex: "allowgstvalue",
//       width: 60,
//       align: "center",
//       render: (v) => (
//         <Tag
//           style={{
//             background: v ? `${EMERALD}15` : `${ROSE}10`,
//             color: v ? EMERALD : ROSE,
//             border: `1px solid ${v ? EMERALD : ROSE}44`,
//             borderRadius: 6,
//             fontWeight: 600,
//             fontSize: 11,
//           }}
//         >
//           {v ? "Yes" : "No"}
//         </Tag>
//       ),
//     },
//     {
//       title: "Effect",
//       dataIndex: "effecttopurchases",
//       width: 70,
//       align: "center",
//       render: (v) => (
//         <Tag
//           style={{
//             background: v ? `${INDIGO}12` : "#f1f5f9",
//             color: v ? INDIGO : "#94a3b8",
//             border: `1px solid ${v ? INDIGO : "#e2e8f0"}`,
//             borderRadius: 6,
//             fontWeight: 600,
//             fontSize: 11,
//           }}
//         >
//           {v ? "Yes" : "No"}
//         </Tag>
//       ),
//     },
//     {
//       title: "Actions",
//       width: 96,
//       align: "center",
//       render: (_, record) => (
//         <div style={{ display: "flex", gap: 6, justifyContent: "center" }}>
//           <Tooltip title="Edit">
//             <Button
//               size="small"
//               icon={<EditOutlined />}
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleEdit(record);
//               }}
//               style={{
//                 background: `${INDIGO}15`,
//                 color: INDIGO,
//                 border: `1px solid ${INDIGO}33`,
//                 borderRadius: 8,
//               }}
//             />
//           </Tooltip>
//           <Popconfirm
//             title="Delete this purchase type?"
//             description="This action cannot be undone."
//             onConfirm={(e) => {
//               e?.stopPropagation?.();
//               handleDelete(record);
//             }}
//             onCancel={(e) => e?.stopPropagation?.()}
//             okText="Delete"
//             cancelText="Cancel"
//             okButtonProps={{ danger: true }}
//           >
//             <Tooltip title="Delete">
//               <Button
//                 size="small"
//                 icon={<DeleteOutlined />}
//                 onClick={(e) => e.stopPropagation()}
//                 style={{
//                   background: `${ROSE}15`,
//                   color: ROSE,
//                   border: `1px solid ${ROSE}33`,
//                   borderRadius: 8,
//                 }}
//               />
//             </Tooltip>
//           </Popconfirm>
//         </div>
//       ),
//     },
//   ];

//   /* ── render ─────────────────────────────────────────────── */
//   return (
//     <div style={G.page}>
//       {/* ── Page Header ──────────────────────────────────── */}
//       <div style={G.headerBar}>
//         <div style={G.headerLeft}>
//           <div style={G.headerIcon}>
//             <ShoppingCartOutlined />
//           </div>
//           <div>
//             <h1 style={G.headerTitle}>Purchase Type Master</h1>
//             <p style={G.headerSub}>
//               Manage purchase types and GST configurations
//             </p>
//           </div>
//         </div>

//         <div style={G.statsRow}>
//           <div style={G.stat(ORANGE)}>
//             <span style={G.statNum(ORANGE)}>{tableData.length}</span>
//             <span style={G.statLabel}>Total</span>
//           </div>
//           <div style={G.stat(EMERALD)}>
//             <span style={G.statNum(EMERALD)}>
//               {tableData.filter((r) => r.allowgstvalue).length}
//             </span>
//             <span style={G.statLabel}>GST On</span>
//           </div>
//           <div style={G.stat(INDIGO)}>
//             <span style={G.statNum(INDIGO)}>
//               {tableData.filter((r) => r.effecttopurchases).length}
//             </span>
//             <span style={G.statLabel}>Effective</span>
//           </div>
//         </div>
//       </div>

//       {/* ── Two-panel layout ─────────────────────────────── */}
//       <Row gutter={[20, 20]} align="top">
//         {/* ── Table Panel ──────────────────────────────── */}
//         <Col xs={24} xl={15}>
//           <div style={G.card}>
//             <div style={G.panelHead(ORANGE, AMBER)}>
//               <span style={G.panelTitle}>
//                 <UnorderedListOutlined style={{ fontSize: 16 }} />
//                 All Purchase Types
//               </span>
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   background: "rgba(255,255,255,0.18)",
//                   borderRadius: 20,
//                   padding: "3px 12px 3px 8px",
//                   gap: 6,
//                   minWidth: 220,
//                 }}
//               >
//                 <SearchOutlined
//                   style={{ color: "rgba(255,255,255,0.8)", fontSize: 14 }}
//                 />
//                 <input
//                   className="ptm-search"
//                   value={filter}
//                   onChange={(e) => setFilter(e.target.value)}
//                   placeholder="Search type or code…"
//                   style={{
//                     background: "transparent",
//                     border: "none",
//                     outline: "none",
//                     color: "#fff",
//                     fontSize: 13,
//                     width: "100%",
//                   }}
//                 />
//                 {filter && (
//                   <CloseCircleOutlined
//                     style={{
//                       color: "rgba(255,255,255,0.7)",
//                       cursor: "pointer",
//                       fontSize: 13,
//                     }}
//                     onClick={() => setFilter("")}
//                   />
//                 )}
//               </div>
//             </div>

//             <div style={{ padding: "4px 0" }}>
//               <Table
//                 columns={columns}
//                 dataSource={filteredData}
//                 loading={loading}
//                 size="middle"
//                 pagination={false}
//                 scroll={{ x: 700, y: "calc(100vh - 320px)" }}
//                 rowClassName={(record) =>
//                   record.key === editingKey ? "ptm-row-selected" : "ptm-row"
//                 }
//                 onRow={(record) => ({
//                   onClick: () => handleEdit(record),
//                   style: { cursor: "pointer" },
//                 })}
//               />
//             </div>
//           </div>
//         </Col>

//         {/* ── Form Panel ───────────────────────────────── */}
//         <Col xs={24} xl={9}>
//           <div style={G.card}>
//             <div style={G.panelHead(ORANGE, AMBER)}>
//               <span style={G.panelTitle}>
//                 <FormOutlined style={{ fontSize: 16 }} />
//                 {editingKey != null
//                   ? "Edit Purchase Type"
//                   : "Add Purchase Type"}
//               </span>
//               {editingKey != null && (
//                 <Tooltip title="Cancel editing">
//                   <button
//                     type="button"
//                     onClick={handleCancel}
//                     style={{
//                       background: "rgba(255,255,255,0.2)",
//                       border: "none",
//                       color: "#fff",
//                       borderRadius: 8,
//                       width: 28,
//                       height: 28,
//                       cursor: "pointer",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       fontSize: 14,
//                     }}
//                   >
//                     <CloseCircleOutlined />
//                   </button>
//                 </Tooltip>
//               )}
//             </div>

//             <div style={G.panelBody}>
//               {/* Context badge */}
//               {editingKey == null ? (
//                 <div style={G.hint}>
//                   <PlusCircleOutlined style={{ color: ORANGE, fontSize: 15 }} />
//                   <span>
//                     Fill in the details below to add a new purchase type.
//                   </span>
//                 </div>
//               ) : (
//                 editingRecord && (
//                   <div style={G.selectedBadge(ORANGE)}>
//                     <div style={G.badgeAvatar(ORANGE)}>
//                       <ShoppingCartOutlined />
//                     </div>
//                     <div>
//                       <div
//                         style={{
//                           fontWeight: 700,
//                           color: "#1e293b",
//                           fontSize: 13,
//                         }}
//                       >
//                         {editingRecord.pType}
//                       </div>
//                       <div
//                         style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}
//                       >
//                         Code: {editingRecord.pCode} &nbsp;|&nbsp; Entry No:{" "}
//                         {editingRecord.pno}
//                       </div>
//                     </div>
//                   </div>
//                 )
//               )}

//               <Form
//                 form={form}
//                 layout="vertical"
//                 onFinish={handleSubmit}
//                 onKeyDown={handleFormKeyDown}
//                 requiredMark={false}
//                 initialValues={{
//                   discount: 0,
//                   vatper: 0,
//                   pno: 0,
//                   bellowvalue: 0,
//                   bellowper: 0,
//                   abovevalue: 0,
//                   aboveper: 0,
//                   allowgstvalue: false,
//                   effecttopurchases: false,
//                   allowtaans: false,
//                   defaultgstvale: false,
//                   defaultgstper: 0,
//                 }}
//               >
//                 {/* ── Basic Details ─────────────────────── */}
//                 <div style={G.sectionLabel(ORANGE)}>
//                   <span style={G.dot(ORANGE)} /> Basic Details
//                 </div>

//                 <Row gutter={12}>
//                   <Col span={16}>
//                     <Form.Item
//                       label={
//                         <span
//                           style={{
//                             fontWeight: 600,
//                             color: "#374151",
//                             fontSize: 13,
//                           }}
//                         >
//                           Purchase Type <span style={{ color: ROSE }}>*</span>
//                         </span>
//                       }
//                       name="pType"
//                       rules={[
//                         {
//                           required: true,
//                           message: "Purchase type is required",
//                         },
//                       ]}
//                     >
//                       <Input
//                         ref={pTypeRef}
//                         placeholder="e.g. READYMADES"
//                         prefix={
//                           <TagOutlined
//                             style={{ color: ORANGE, fontSize: 14 }}
//                           />
//                         }
//                         style={G.inputStyle}
//                       />
//                     </Form.Item>
//                   </Col>
//                   <Col span={8}>
//                     <Form.Item
//                       label={
//                         <span
//                           style={{
//                             fontWeight: 600,
//                             color: "#374151",
//                             fontSize: 13,
//                           }}
//                         >
//                           Code
//                         </span>
//                       }
//                       name="pCode"
//                     >
//                       <Input
//                         placeholder="e.g. BR"
//                         prefix={
//                           <NumberOutlined
//                             style={{ color: SKY, fontSize: 14 }}
//                           />
//                         }
//                         style={G.inputStyle}
//                       />
//                     </Form.Item>
//                   </Col>
//                 </Row>

//                 <Row gutter={12}>
//                   <Col span={8}>
//                     <Form.Item
//                       label={
//                         <span
//                           style={{
//                             fontWeight: 600,
//                             color: "#374151",
//                             fontSize: 13,
//                           }}
//                         >
//                           Entry No
//                         </span>
//                       }
//                       name="pno"
//                     >
//                       <InputNumber min={0} style={G.numStyle} />
//                     </Form.Item>
//                   </Col>
//                   <Col span={8}>
//                     <Form.Item
//                       label={
//                         <span
//                           style={{
//                             fontWeight: 600,
//                             color: "#374151",
//                             fontSize: 13,
//                           }}
//                         >
//                           Discount %
//                         </span>
//                       }
//                       name="discount"
//                     >
//                       <InputNumber min={0} max={100} style={G.numStyle} />
//                     </Form.Item>
//                   </Col>
//                   <Col span={8}>
//                     <Form.Item
//                       label={
//                         <span
//                           style={{
//                             fontWeight: 600,
//                             color: "#374151",
//                             fontSize: 13,
//                           }}
//                         >
//                           VAT %
//                         </span>
//                       }
//                       name="vatper"
//                     >
//                       <InputNumber min={0} max={100} style={G.numStyle} />
//                     </Form.Item>
//                   </Col>
//                 </Row>

//                 {/* ── GST mode: Allow GST OR Default GST (not both) ── */}
//                 <div style={G.sectionLabel(TEAL)}>
//                   <span style={G.dot(TEAL)} /> GST (choose one)
//                 </div>

//                 {/* Allow GST + conditional fields */}
//                 <div style={G.gstBox}>
//                   <Form.Item
//                     name="allowgstvalue"
//                     valuePropName="checked"
//                     style={{ marginBottom: 0 }}
//                   >
//                     <Checkbox
//                       onChange={handleAllowGstChange}
//                       style={{ fontWeight: 700, color: TEAL, fontSize: 13 }}
//                     >
//                       Allow GST
//                     </Checkbox>
//                   </Form.Item>

//                   {allowGst && (
//                     <>
//                       {/* Column headers */}
//                       <div
//                         style={{
//                           display: "grid",
//                           gridTemplateColumns: "60px 1fr 1fr",
//                           gap: "0 16px",
//                           marginTop: 12,
//                           marginBottom: 4,
//                         }}
//                       >
//                         <div />
//                         <div style={{ ...G.gridLabel, textAlign: "center" }}>
//                           BELLOW
//                         </div>
//                         <div style={{ ...G.gridLabel, textAlign: "center" }}>
//                           ABOVE
//                         </div>
//                       </div>

//                       {/* VALUE + (%) rows */}
//                       <div
//                         style={{
//                           display: "grid",
//                           gridTemplateColumns: "60px 1fr 1fr",
//                           gap: "8px 16px",
//                           alignItems: "center",
//                         }}
//                       >
//                         <div
//                           style={{
//                             fontSize: 12,
//                             fontWeight: 700,
//                             color: "#475569",
//                           }}
//                         >
//                           VALUE
//                         </div>
//                         <Form.Item
//                           name="bellowvalue"
//                           style={{ marginBottom: 0 }}
//                         >
//                           <InputNumber
//                             min={0}
//                             style={{
//                               width: "100%",
//                               borderRadius: 8,
//                               fontSize: 13,
//                             }}
//                           />
//                         </Form.Item>
//                         <Form.Item
//                           name="abovevalue"
//                           style={{ marginBottom: 0 }}
//                         >
//                           <InputNumber
//                             min={0}
//                             style={{
//                               width: "100%",
//                               borderRadius: 8,
//                               fontSize: 13,
//                             }}
//                           />
//                         </Form.Item>

//                         <div
//                           style={{
//                             fontSize: 12,
//                             fontWeight: 700,
//                             color: "#475569",
//                           }}
//                         >
//                           (%)
//                         </div>
//                         <Form.Item name="bellowper" style={{ marginBottom: 0 }}>
//                           <InputNumber
//                             min={0}
//                             max={100}
//                             style={{
//                               width: "100%",
//                               borderRadius: 8,
//                               fontSize: 13,
//                             }}
//                           />
//                         </Form.Item>
//                         <Form.Item name="aboveper" style={{ marginBottom: 0 }}>
//                           <InputNumber
//                             min={0}
//                             max={100}
//                             style={{
//                               width: "100%",
//                               borderRadius: 8,
//                               fontSize: 13,
//                             }}
//                           />
//                         </Form.Item>
//                       </div>
//                     </>
//                   )}
//                 </div>

//                 {/* Default GST + conditional % field */}
//                 <div style={G.defaultGstBox}>
//                   <Form.Item
//                     name="defaultgstvale"
//                     valuePropName="checked"
//                     style={{ marginBottom: defaultGst ? 8 : 0 }}
//                   >
//                     <Checkbox
//                       onChange={handleDefaultGstChange}
//                       style={{ fontWeight: 700, color: AMBER, fontSize: 13 }}
//                     >
//                       Default GST Value
//                     </Checkbox>
//                   </Form.Item>

//                   {defaultGst && (
//                     <Form.Item
//                       label={
//                         <span
//                           style={{
//                             fontWeight: 600,
//                             color: "#374151",
//                             fontSize: 13,
//                           }}
//                         >
//                           Default GST %
//                         </span>
//                       }
//                       name="defaultgstper"
//                       style={{ marginBottom: 0 }}
//                     >
//                       <InputNumber
//                         min={0}
//                         max={100}
//                         style={{ width: "100%", borderRadius: 8, fontSize: 13 }}
//                       />
//                     </Form.Item>
//                   )}
//                 </div>

//                 {/* ── Toggles ───────────────────────────── */}
//                 <div
//                   style={{
//                     background:
//                       "linear-gradient(135deg,#eef2ff 0%,#e0e7ff 100%)",
//                     border: "1px solid #c7d2fe",
//                     borderRadius: 12,
//                     padding: "12px 16px",
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: 10,
//                     marginBottom: 14,
//                   }}
//                 >
//                   <Form.Item
//                     name="effecttopurchases"
//                     valuePropName="checked"
//                     style={{ marginBottom: 0 }}
//                   >
//                     <Checkbox
//                       style={{ fontWeight: 600, color: INDIGO, fontSize: 13 }}
//                     >
//                       Effect To Purchases
//                     </Checkbox>
//                   </Form.Item>
//                   <Form.Item
//                     name="allowtaans"
//                     valuePropName="checked"
//                     style={{ marginBottom: 0 }}
//                   >
//                     <Checkbox
//                       style={{ fontWeight: 600, color: INDIGO, fontSize: 13 }}
//                     >
//                       Allow Taan Entry
//                     </Checkbox>
//                   </Form.Item>
//                 </div>

//                 {/* ── Action Buttons ────────────────────── */}
//                 <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//                   <Button
//                     type="primary"
//                     htmlType="submit"
//                     loading={saving}
//                     icon={
//                       editingKey != null ? (
//                         <SaveOutlined />
//                       ) : (
//                         <PlusCircleOutlined />
//                       )
//                     }
//                     style={{
//                       background: `linear-gradient(90deg,${ORANGE} 0%,${AMBER} 100%)`,
//                       border: "none",
//                       borderRadius: 10,
//                       height: 42,
//                       fontWeight: 700,
//                       fontSize: 13,
//                       flex: 1,
//                       boxShadow: `0 4px 14px ${ORANGE}44`,
//                     }}
//                   >
//                     {editingKey != null ? "Update" : "Save"}
//                   </Button>

//                   <Button
//                     onClick={handleCancel}
//                     icon={<CloseCircleOutlined />}
//                     style={{
//                       borderRadius: 10,
//                       height: 42,
//                       fontWeight: 600,
//                       border: `1px solid ${ROSE}44`,
//                       color: ROSE,
//                       background: `${ROSE}08`,
//                     }}
//                   >
//                     Cancel
//                   </Button>

//                   <Tooltip title="Refresh">
//                     <Button
//                       icon={<ReloadOutlined />}
//                       onClick={handleRefresh}
//                       loading={loading}
//                       style={{
//                         borderRadius: 10,
//                         height: 42,
//                         border: `1px solid ${TEAL}44`,
//                         color: TEAL,
//                         background: `${TEAL}08`,
//                       }}
//                     />
//                   </Tooltip>
//                 </div>
//               </Form>
//             </div>
//           </div>
//         </Col>
//       </Row>

//       <style>{`
//         .ptm-row:hover td { background: #fff7ed !important; transition: background 0.15s; }
//         .ptm-row-selected td { background: #ffedd5 !important; }
//         .ptm-row-selected:hover td { background: #fed7aa !important; }
//         .ptm-search::placeholder { color: rgba(255,255,255,0.8); opacity: 1; }
//         .ptm-search::-webkit-input-placeholder { color: rgba(255,255,255,0.8); opacity: 1; }
//       `}</style>
//     </div>
//   );
// }

import { useEffect, useRef, useState } from "react";
import axios from "axios";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Popconfirm,
  Row,
  Table,
  Tag,
  Tooltip,
} from "antd";
import {
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  FormOutlined,
  PlusCircleOutlined,
  ReloadOutlined,
  SaveOutlined,
  SearchOutlined,
  ShoppingCartOutlined,
  UnorderedListOutlined,
  NumberOutlined,
  PercentageOutlined,
  TagOutlined,
} from "@ant-design/icons";
import { CREATE_jwel } from "../../Config/Config";

const tenantName = localStorage.getItem("tenantName");

/* ─── palette ───────────────────────────────────────────── */
const PURPLE = "#7c3aed";
const INDIGO = "#4f46e5";
const TEAL = "#0d9488";
const AMBER = "#d97706";
const ROSE = "#e11d48";
const EMERALD = "#059669";
const SKY = "#0284c7";
const ORANGE = "#ea580c";

/* ─── shared styles ─────────────────────────────────────── */
const G = {
  page: {
    background: "linear-gradient(135deg,#f5f3ff 0%,#eff6ff 40%,#ecfdf5 100%)",
    minHeight: "calc(100vh - 105px)",
    padding: "20px 24px",
  },
  headerBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12,
    marginBottom: 16,
  },
  headerLeft: { display: "flex", alignItems: "center", gap: 14 },
  headerIcon: {
    width: 52,
    height: 52,
    borderRadius: 14,
    background: `linear-gradient(135deg,${ORANGE} 0%,${AMBER} 100%)`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 26,
    color: "#fff",
    boxShadow: `0 6px 18px ${ORANGE}55`,
  },
  headerTitle: {
    margin: 0,
    fontSize: 22,
    fontWeight: 800,
    background: `linear-gradient(90deg,${ORANGE},${AMBER})`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    letterSpacing: 0.3,
  },
  headerSub: { margin: 0, fontSize: 13, color: "#64748b", marginTop: 2 },
  statsRow: { display: "flex", gap: 12, flexWrap: "wrap" },
  stat: (color) => ({
    background: "#fff",
    borderRadius: 12,
    padding: "10px 18px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxShadow: "0 2px 10px rgba(0,0,0,0.07)",
    borderTop: `3px solid ${color}`,
    minWidth: 80,
  }),
  statNum: (color) => ({
    fontSize: 22,
    fontWeight: 800,
    color,
    lineHeight: 1.1,
  }),
  statLabel: {
    fontSize: 11,
    color: "#94a3b8",
    fontWeight: 600,
    marginTop: 2,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  card: {
    background: "#fff",
    borderRadius: 18,
    boxShadow: "0 4px 28px rgba(0,0,0,0.09)",
    overflow: "hidden",
  },
  panelHead: (from, to) => ({
    background: `linear-gradient(120deg,${from} 0%,${to} 100%)`,
    padding: "14px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
  }),
  panelTitle: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    color: "#fff",
    fontWeight: 700,
    fontSize: 14,
    letterSpacing: 0.4,
    textTransform: "uppercase",
  },
  panelBody: { padding: "22px 22px 18px" },
  inputStyle: { height: 38, borderRadius: 10, fontSize: 13 },
  numStyle: { width: "100%", height: 38, borderRadius: 10, fontSize: 13 },
  sectionLabel: (color) => ({
    display: "flex",
    alignItems: "center",
    gap: 7,
    fontSize: 11,
    fontWeight: 700,
    color,
    textTransform: "uppercase",
    letterSpacing: 0.8,
    marginBottom: 10,
    marginTop: 4,
  }),
  dot: (color) => ({
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: color,
    flexShrink: 0,
  }),
  hint: {
    background: "#f8fafc",
    border: "1px dashed #cbd5e1",
    borderRadius: 10,
    padding: "10px 14px",
    fontSize: 12,
    color: "#94a3b8",
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 16,
  },
  selectedBadge: (color) => ({
    background: `${color}18`,
    border: `1px solid ${color}44`,
    borderRadius: 10,
    padding: "8px 14px",
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 16,
  }),
  badgeAvatar: (color) => ({
    width: 36,
    height: 36,
    borderRadius: 10,
    background: `linear-gradient(135deg,${color} 0%,${color}99 100%)`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: 18,
    flexShrink: 0,
  }),
  gstBox: {
    background: "linear-gradient(135deg,#f0fdf4 0%,#ecfdf5 100%)",
    border: "1px solid #bbf7d0",
    borderRadius: 12,
    padding: "14px 16px",
    marginBottom: 10,
  },
  defaultGstBox: {
    background: "linear-gradient(135deg,#fefce8 0%,#fef9c3 100%)",
    border: "1px solid #fde68a",
    borderRadius: 12,
    padding: "12px 16px",
    marginBottom: 14,
  },
  gridLabel: {
    fontSize: 11,
    fontWeight: 700,
    color: TEAL,
    textTransform: "uppercase",
    letterSpacing: 0.6,
    marginBottom: 4,
  },
};

const ROW_COLORS = [ORANGE, SKY, TEAL, EMERALD, AMBER, ROSE, INDIGO, PURPLE];

/* ════════════════════════════════════════════════════════════ */
export default function PurchaseTypeMaster() {
  const [form] = Form.useForm();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [editingKey, setEditingKey] = useState(null);
  const [filter, setFilter] = useState("");
  const [allowGst, setAllowGst] = useState(false);
  const [defaultGst, setDefaultGst] = useState(false);

  const pTypeRef = useRef(null);

  /* ── fetch ──────────────────────────────────────────────── */
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName`,
        { params: { tableName: "purchase_type" }, headers: { tenantName } },
      );
      const rows = (res.data || []).map((item, idx) => ({
        key: idx,
        pType: item.PType ?? item.pType ?? "-",
        discount: item.Discount ?? item.discount ?? 0,
        vatper: item.VATPER ?? item.vatper ?? 0,
        pCode: item.PCode ?? item.pCode ?? "-",
        pno: item.PNO ?? item.pno ?? 0,
        bellowvalue: item.BELLOWVALUE ?? item.bellowvalue ?? 0,
        bellowper: item.BELLOWPER ?? item.bellowper ?? 0,
        abovevalue: item.ABOVEVALUE ?? item.abovevalue ?? 0,
        aboveper: item.ABOVEPER ?? item.aboveper ?? 0,
        allowgstvalue: item.ALLOWGSTVALUE ?? item.allowgstvalue ?? false,
        effecttopurchases:
          item.EFFECTTOPURCHASES ?? item.effecttopurchases ?? false,
        allowtaans: item.ALLOWTAANS ?? item.allowtaans ?? false,
        bellowvalue_purch:
          item.BELLOWVALUE_PURCH ?? item.bellowvalue_purch ?? 0,
        abovevalue_purch: item.ABOVEVALUE_PURCH ?? item.abovevalue_purch ?? 0,
        defaultgstvale: item.DEFAULTGSTVALE ?? item.defaultgstvale ?? false,
        defaultgstper: item.DEFAULTGSTPER ?? item.defaultgstper ?? 0,
      }));
      setTableData(rows);
    } catch {
      message.error("Failed to load purchase type data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    setTimeout(() => pTypeRef.current?.focus(), 300);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  /* ── derived ────────────────────────────────────────────── */
  const q = filter.trim().toLowerCase();
  const filteredData = q
    ? tableData.filter(
        (r) =>
          r.pType?.toLowerCase().includes(q) ||
          r.pCode?.toLowerCase().includes(q),
      )
    : tableData;

  const editingRecord =
    editingKey != null ? tableData.find((r) => r.key === editingKey) : null;

  /* ── handlers ───────────────────────────────────────────── */

  // Allow GST and Default GST are mutually exclusive.
  const handleAllowGstChange = (e) => {
    const checked = e.target.checked;
    setAllowGst(checked);
    if (checked) {
      setDefaultGst(false);
      form.setFieldsValue({ defaultgstvale: false, defaultgstper: 0 });
    }
  };

  const handleDefaultGstChange = (e) => {
    const checked = e.target.checked;
    setDefaultGst(checked);
    if (checked) {
      setAllowGst(false);
      form.setFieldsValue({
        allowgstvalue: false,
        bellowvalue: 0,
        bellowper: 0,
        abovevalue: 0,
        aboveper: 0,
      });
    } else {
      form.setFieldsValue({ defaultgstper: 0 });
    }
  };

  const handleEdit = (record) => {
    // If legacy data has both flags on, Allow GST wins.
    const isAllow = !!record.allowgstvalue;
    const isDefault = !isAllow && !!record.defaultgstvale;

    setEditingKey(record.key);
    setAllowGst(isAllow);
    setDefaultGst(isDefault);
    form.setFieldsValue({
      pType: record.pType === "-" ? "" : record.pType,
      pCode: record.pCode === "-" ? "" : record.pCode,
      pno: record.pno,
      discount: record.discount,
      vatper: record.vatper,
      allowgstvalue: isAllow,
      bellowvalue: record.bellowvalue,
      bellowper: record.bellowper,
      abovevalue: record.abovevalue,
      aboveper: record.aboveper,
      effecttopurchases: !!record.effecttopurchases,
      allowtaans: !!record.allowtaans,
      defaultgstvale: isDefault,
      defaultgstper: isDefault ? (record.defaultgstper ?? 0) : 0,
    });
    setTimeout(() => pTypeRef.current?.focus(), 100);
  };

  const handleCancel = () => {
    form.resetFields();
    setEditingKey(null);
    setAllowGst(false);
    setDefaultGst(false);
    setFilter("");
    setTimeout(() => pTypeRef.current?.focus(), 100);
  };

  const handleRefresh = () => {
    handleCancel();
    fetchData();
    setTimeout(() => pTypeRef.current?.focus(), 300);
  };

  // Enter moves focus to the next field instead of submitting the form.
  // On the last field it lands on the Save button; Enter there submits.
  const handleFormKeyDown = (e) => {
    if (e.key !== "Enter" || e.target.tagName !== "INPUT") return;
    e.preventDefault();
    const focusables = Array.from(
      e.currentTarget.querySelectorAll(
        'input:not([disabled]):not([type="hidden"]), button[type="submit"]',
      ),
    ).filter((el) => el.offsetParent !== null);
    const idx = focusables.indexOf(e.target);
    const next = focusables[idx + 1];
    if (next) {
      next.focus();
      next.select?.();
    }
  };

  // Delete a purchase type row by its name.
  const deleteByName = async (name) => {
    const safeName = String(name).replace(/'/g, "''");
    await axios.post(
      `${CREATE_jwel}/api/ERP/DeleteDataFromGivenTableNameWithWhere?tableName=purchase_type&where=${encodeURIComponent(`PTYPE='${safeName}'`)}`,
      {},
      { headers: { tenantName } },
    );
  };

  // Insert a purchase type row.
  const insertRecord = (payload) =>
    axios.post(`${CREATE_jwel}/api/Master/PurchaseType`, [payload], {
      headers: { tenantName },
    });

  // Convert a table row back into an API payload (used to restore on failure).
  const recordToPayload = (r) => ({
    pType: r.pType === "-" ? "" : r.pType,
    discount: r.discount ?? 0,
    vatper: r.vatper ?? 0,
    pCode: r.pCode === "-" ? "" : r.pCode,
    pno: r.pno ?? 0,
    bellowvalue: r.bellowvalue ?? 0,
    bellowper: r.bellowper ?? 0,
    abovevalue: r.abovevalue ?? 0,
    aboveper: r.aboveper ?? 0,
    allowgstvalue: !!r.allowgstvalue,
    effecttopurchases: !!r.effecttopurchases,
    allowtaans: !!r.allowtaans,
    bellowvalue_purch: r.bellowvalue_purch ?? 0,
    abovevalue_purch: r.abovevalue_purch ?? 0,
    defaultgstvale: !!r.defaultgstvale,
    defaultgstper: r.defaultgstper ?? 0,
  });

  const handleSubmit = async (values) => {
    setSaving(true);
    const oldRecord = editingKey != null ? editingRecord : null;
    let deleted = false;
    try {
      // Only one of the two GST modes can be saved.
      const useAllow = !!values.allowgstvalue;
      const useDefault = !useAllow && !!values.defaultgstvale;

      const payload = {
        pType: (values.pType || "").trim().toUpperCase(),
        discount: values.discount ?? 0,
        vatper: values.vatper ?? 0,
        pCode: (values.pCode || "").trim().toUpperCase(),
        pno: values.pno ?? 0,
        bellowvalue: useAllow ? (values.bellowvalue ?? 0) : 0,
        bellowper: useAllow ? (values.bellowper ?? 0) : 0,
        abovevalue: useAllow ? (values.abovevalue ?? 0) : 0,
        aboveper: useAllow ? (values.aboveper ?? 0) : 0,
        allowgstvalue: useAllow,
        effecttopurchases: !!values.effecttopurchases,
        allowtaans: !!values.allowtaans,
        // Fields removed from the UI: keep existing values when editing, else 0
        bellowvalue_purch: oldRecord?.bellowvalue_purch ?? 0,
        abovevalue_purch: oldRecord?.abovevalue_purch ?? 0,
        defaultgstvale: useDefault,
        defaultgstper: useDefault ? (values.defaultgstper ?? 0) : 0,
      };

      // Update = delete the old row (by its ORIGINAL name) + insert the new one.
      if (oldRecord && oldRecord.pType && oldRecord.pType !== "-") {
        await deleteByName(oldRecord.pType);
        deleted = true;
      }
      await insertRecord(payload);

      message.success(
        oldRecord ? "Purchase type updated" : "Purchase type added",
        2,
      );
      handleCancel();
      fetchData();
    } catch (err) {
      if (deleted && oldRecord) {
        // Insert failed after the delete went through: put the old row back.
        try {
          await insertRecord(recordToPayload(oldRecord));
          message.error("Update failed. The original record was restored.");
        } catch {
          message.error(
            `Update failed and "${oldRecord.pType}" could not be restored. Please re-add it.`,
            6,
          );
        }
        fetchData();
      } else {
        message.error(err?.response?.data?.message || "Failed to save");
      }
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (record) => {
    try {
      await deleteByName(record.pType);
      message.success("Purchase type deleted");
      if (editingKey === record.key) handleCancel();
      fetchData();
    } catch {
      message.error("Delete failed");
    }
  };

  /* ── table columns ──────────────────────────────────────── */
  const columns = [
    {
      title: "#",
      width: 52,
      align: "center",
      render: (_, __, idx) => {
        const color = ROW_COLORS[idx % ROW_COLORS.length];
        return (
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 28,
              height: 28,
              borderRadius: 8,
              background: `${color}18`,
              color,
              fontWeight: 700,
              fontSize: 12,
            }}
          >
            {idx + 1}
          </span>
        );
      },
    },
    {
      title: (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: 5,
            color: ORANGE,
          }}
        >
          <TagOutlined /> Purchase Type
        </span>
      ),
      dataIndex: "pType",
      render: (v) => (
        <span style={{ fontWeight: 700, color: "#1e293b", fontSize: 13 }}>
          {v}
        </span>
      ),
    },
    {
      title: (
        <span
          style={{ display: "flex", alignItems: "center", gap: 5, color: SKY }}
        >
          <NumberOutlined /> Code
        </span>
      ),
      dataIndex: "pCode",
      width: 90,
      render: (v) =>
        v && v !== "-" ? (
          <Tag
            style={{
              background: `${SKY}15`,
              color: SKY,
              border: `1px solid ${SKY}44`,
              borderRadius: 6,
              fontWeight: 600,
              fontSize: 12,
            }}
          >
            {v}
          </Tag>
        ) : (
          <span style={{ color: "#cbd5e1", fontSize: 12 }}>—</span>
        ),
    },
    {
      title: (
        <span
          style={{ display: "flex", alignItems: "center", gap: 5, color: TEAL }}
        >
          <PercentageOutlined /> VAT %
        </span>
      ),
      dataIndex: "vatper",
      width: 80,
      align: "center",
      render: (v) => (
        <Tag
          style={{
            background: `${TEAL}12`,
            color: TEAL,
            border: `1px solid ${TEAL}33`,
            borderRadius: 6,
            fontWeight: 600,
            fontSize: 12,
          }}
        >
          {v ?? 0}%
        </Tag>
      ),
    },
    {
      title: "GST",
      dataIndex: "allowgstvalue",
      width: 60,
      align: "center",
      render: (v) => (
        <Tag
          style={{
            background: v ? `${EMERALD}15` : `${ROSE}10`,
            color: v ? EMERALD : ROSE,
            border: `1px solid ${v ? EMERALD : ROSE}44`,
            borderRadius: 6,
            fontWeight: 600,
            fontSize: 11,
          }}
        >
          {v ? "Yes" : "No"}
        </Tag>
      ),
    },
    {
      title: "Effect",
      dataIndex: "effecttopurchases",
      width: 70,
      align: "center",
      render: (v) => (
        <Tag
          style={{
            background: v ? `${INDIGO}12` : "#f1f5f9",
            color: v ? INDIGO : "#94a3b8",
            border: `1px solid ${v ? INDIGO : "#e2e8f0"}`,
            borderRadius: 6,
            fontWeight: 600,
            fontSize: 11,
          }}
        >
          {v ? "Yes" : "No"}
        </Tag>
      ),
    },
    {
      title: "Actions",
      width: 96,
      align: "center",
      render: (_, record) => (
        <div style={{ display: "flex", gap: 6, justifyContent: "center" }}>
          <Tooltip title="Edit">
            <Button
              size="small"
              icon={<EditOutlined />}
              onClick={(e) => {
                e.stopPropagation();
                handleEdit(record);
              }}
              style={{
                background: `${INDIGO}15`,
                color: INDIGO,
                border: `1px solid ${INDIGO}33`,
                borderRadius: 8,
              }}
            />
          </Tooltip>
          <Popconfirm
            title="Delete this purchase type?"
            description="This action cannot be undone."
            onConfirm={(e) => {
              e?.stopPropagation?.();
              handleDelete(record);
            }}
            onCancel={(e) => e?.stopPropagation?.()}
            okText="Delete"
            cancelText="Cancel"
            okButtonProps={{ danger: true }}
          >
            <Tooltip title="Delete">
              <Button
                size="small"
                icon={<DeleteOutlined />}
                onClick={(e) => e.stopPropagation()}
                style={{
                  background: `${ROSE}15`,
                  color: ROSE,
                  border: `1px solid ${ROSE}33`,
                  borderRadius: 8,
                }}
              />
            </Tooltip>
          </Popconfirm>
        </div>
      ),
    },
  ];

  /* ── render ─────────────────────────────────────────────── */
  return (
    <div style={G.page}>
      {/* ── Page Header ──────────────────────────────────── */}
      <div style={G.headerBar}>
        <div style={G.headerLeft}>
          <div style={G.headerIcon}>
            <ShoppingCartOutlined />
          </div>
          <div>
            <h1 style={G.headerTitle}>Purchase Type Master</h1>
            <p style={G.headerSub}>
              Manage purchase types and GST configurations
            </p>
          </div>
        </div>

        <div style={G.statsRow}>
          <div style={G.stat(ORANGE)}>
            <span style={G.statNum(ORANGE)}>{tableData.length}</span>
            <span style={G.statLabel}>Total</span>
          </div>
          <div style={G.stat(EMERALD)}>
            <span style={G.statNum(EMERALD)}>
              {tableData.filter((r) => r.allowgstvalue).length}
            </span>
            <span style={G.statLabel}>GST On</span>
          </div>
          <div style={G.stat(INDIGO)}>
            <span style={G.statNum(INDIGO)}>
              {tableData.filter((r) => r.effecttopurchases).length}
            </span>
            <span style={G.statLabel}>Effective</span>
          </div>
        </div>
      </div>

      {/* ── Two-panel layout ─────────────────────────────── */}
      <Row gutter={[20, 20]} align="top">
        {/* ── Table Panel ──────────────────────────────── */}
        <Col xs={24} xl={15}>
          <div style={G.card}>
            <div style={G.panelHead(ORANGE, AMBER)}>
              <span style={G.panelTitle}>
                <UnorderedListOutlined style={{ fontSize: 16 }} />
                All Purchase Types
              </span>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "rgba(255,255,255,0.18)",
                  borderRadius: 20,
                  padding: "3px 12px 3px 8px",
                  gap: 6,
                  minWidth: 220,
                }}
              >
                <SearchOutlined
                  style={{ color: "rgba(255,255,255,0.8)", fontSize: 14 }}
                />
                <input
                  className="ptm-search"
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                  placeholder="Search type or code…"
                  style={{
                    background: "transparent",
                    border: "none",
                    outline: "none",
                    color: "#fff",
                    fontSize: 13,
                    width: "100%",
                  }}
                />
                {filter && (
                  <CloseCircleOutlined
                    style={{
                      color: "rgba(255,255,255,0.7)",
                      cursor: "pointer",
                      fontSize: 13,
                    }}
                    onClick={() => setFilter("")}
                  />
                )}
              </div>
            </div>

            <div style={{ padding: "4px 0" }}>
              <Table
                columns={columns}
                dataSource={filteredData}
                loading={loading}
                size="middle"
                pagination={false}
                scroll={{ x: 700, y: "calc(100vh - 320px)" }}
                rowClassName={(record) =>
                  record.key === editingKey ? "ptm-row-selected" : "ptm-row"
                }
                onRow={(record) => ({
                  onClick: () => handleEdit(record),
                  style: { cursor: "pointer" },
                })}
              />
            </div>
          </div>
        </Col>

        {/* ── Form Panel ───────────────────────────────── */}
        <Col xs={24} xl={9}>
          <div style={G.card}>
            <div style={G.panelHead(ORANGE, AMBER)}>
              <span style={G.panelTitle}>
                <FormOutlined style={{ fontSize: 16 }} />
                {editingKey != null
                  ? "Edit Purchase Type"
                  : "Add Purchase Type"}
              </span>
              {editingKey != null && (
                <Tooltip title="Cancel editing">
                  <button
                    type="button"
                    onClick={handleCancel}
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      border: "none",
                      color: "#fff",
                      borderRadius: 8,
                      width: 28,
                      height: 28,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 14,
                    }}
                  >
                    <CloseCircleOutlined />
                  </button>
                </Tooltip>
              )}
            </div>

            <div style={G.panelBody}>
              {/* Context badge */}
              {editingKey == null ? (
                <div style={G.hint}>
                  <PlusCircleOutlined style={{ color: ORANGE, fontSize: 15 }} />
                  <span>
                    Fill in the details below to add a new purchase type.
                  </span>
                </div>
              ) : (
                editingRecord && (
                  <div style={G.selectedBadge(ORANGE)}>
                    <div style={G.badgeAvatar(ORANGE)}>
                      <ShoppingCartOutlined />
                    </div>
                    <div>
                      <div
                        style={{
                          fontWeight: 700,
                          color: "#1e293b",
                          fontSize: 13,
                        }}
                      >
                        {editingRecord.pType}
                      </div>
                      <div
                        style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}
                      >
                        Code: {editingRecord.pCode} &nbsp;|&nbsp; Entry No:{" "}
                        {editingRecord.pno}
                      </div>
                    </div>
                  </div>
                )
              )}

              <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                onKeyDown={handleFormKeyDown}
                requiredMark={false}
                initialValues={{
                  discount: 0,
                  vatper: 0,
                  pno: 0,
                  bellowvalue: 0,
                  bellowper: 0,
                  abovevalue: 0,
                  aboveper: 0,
                  allowgstvalue: false,
                  effecttopurchases: false,
                  allowtaans: false,
                  defaultgstvale: false,
                  defaultgstper: 0,
                }}
              >
                {/* ── Basic Details ─────────────────────── */}
                <div style={G.sectionLabel(ORANGE)}>
                  <span style={G.dot(ORANGE)} /> Basic Details
                </div>

                <Row gutter={12}>
                  <Col span={16}>
                    <Form.Item
                      label={
                        <span
                          style={{
                            fontWeight: 600,
                            color: "#374151",
                            fontSize: 13,
                          }}
                        >
                          Purchase Type <span style={{ color: ROSE }}>*</span>
                        </span>
                      }
                      name="pType"
                      rules={[
                        {
                          required: true,
                          message: "Purchase type is required",
                        },
                      ]}
                    >
                      <Input
                        ref={pTypeRef}
                        placeholder="e.g. READYMADES"
                        prefix={
                          <TagOutlined
                            style={{ color: ORANGE, fontSize: 14 }}
                          />
                        }
                        style={G.inputStyle}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      label={
                        <span
                          style={{
                            fontWeight: 600,
                            color: "#374151",
                            fontSize: 13,
                          }}
                        >
                          Code
                        </span>
                      }
                      name="pCode"
                    >
                      <Input
                        placeholder="e.g. BR"
                        prefix={
                          <NumberOutlined
                            style={{ color: SKY, fontSize: 14 }}
                          />
                        }
                        style={G.inputStyle}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={12}>
                  <Col span={8}>
                    <Form.Item
                      label={
                        <span
                          style={{
                            fontWeight: 600,
                            color: "#374151",
                            fontSize: 13,
                          }}
                        >
                          Entry No
                        </span>
                      }
                      name="pno"
                    >
                      <InputNumber min={0} style={G.numStyle} />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      label={
                        <span
                          style={{
                            fontWeight: 600,
                            color: "#374151",
                            fontSize: 13,
                          }}
                        >
                          Discount %
                        </span>
                      }
                      name="discount"
                    >
                      <InputNumber min={0} max={100} style={G.numStyle} />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      label={
                        <span
                          style={{
                            fontWeight: 600,
                            color: "#374151",
                            fontSize: 13,
                          }}
                        >
                          VAT %
                        </span>
                      }
                      name="vatper"
                    >
                      <InputNumber min={0} max={100} style={G.numStyle} />
                    </Form.Item>
                  </Col>
                </Row>

                {/* ── GST mode: Allow GST OR Default GST (not both) ── */}
                <div style={G.sectionLabel(TEAL)}>
                  <span style={G.dot(TEAL)} /> GST (choose one)
                </div>

                {/* Allow GST + conditional fields */}
                <div style={G.gstBox}>
                  <Form.Item
                    name="allowgstvalue"
                    valuePropName="checked"
                    style={{ marginBottom: 0 }}
                  >
                    <Checkbox
                      onChange={handleAllowGstChange}
                      style={{ fontWeight: 700, color: TEAL, fontSize: 13 }}
                    >
                      Allow GST
                    </Checkbox>
                  </Form.Item>

                  {allowGst && (
                    <>
                      {/* Column headers */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "60px 1fr 1fr",
                          gap: "0 16px",
                          marginTop: 12,
                          marginBottom: 4,
                        }}
                      >
                        <div />
                        <div style={{ ...G.gridLabel, textAlign: "center" }}>
                          BELLOW
                        </div>
                        <div style={{ ...G.gridLabel, textAlign: "center" }}>
                          ABOVE
                        </div>
                      </div>

                      {/* VALUE + (%) rows */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "60px 1fr 1fr",
                          gap: "8px 16px",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            fontSize: 12,
                            fontWeight: 700,
                            color: "#475569",
                          }}
                        >
                          VALUE
                        </div>
                        <Form.Item
                          name="bellowvalue"
                          style={{ marginBottom: 0 }}
                        >
                          <InputNumber
                            min={0}
                            style={{
                              width: "100%",
                              borderRadius: 8,
                              fontSize: 13,
                            }}
                          />
                        </Form.Item>
                        <Form.Item
                          name="abovevalue"
                          style={{ marginBottom: 0 }}
                        >
                          <InputNumber
                            min={0}
                            style={{
                              width: "100%",
                              borderRadius: 8,
                              fontSize: 13,
                            }}
                          />
                        </Form.Item>

                        <div
                          style={{
                            fontSize: 12,
                            fontWeight: 700,
                            color: "#475569",
                          }}
                        >
                          (%)
                        </div>
                        <Form.Item name="bellowper" style={{ marginBottom: 0 }}>
                          <InputNumber
                            min={0}
                            max={100}
                            style={{
                              width: "100%",
                              borderRadius: 8,
                              fontSize: 13,
                            }}
                          />
                        </Form.Item>
                        <Form.Item name="aboveper" style={{ marginBottom: 0 }}>
                          <InputNumber
                            min={0}
                            max={100}
                            style={{
                              width: "100%",
                              borderRadius: 8,
                              fontSize: 13,
                            }}
                          />
                        </Form.Item>
                      </div>
                    </>
                  )}
                </div>

                {/* Default GST + conditional % field */}
                <div style={G.defaultGstBox}>
                  <Form.Item
                    name="defaultgstvale"
                    valuePropName="checked"
                    style={{ marginBottom: defaultGst ? 8 : 0 }}
                  >
                    <Checkbox
                      onChange={handleDefaultGstChange}
                      style={{ fontWeight: 700, color: AMBER, fontSize: 13 }}
                    >
                      Default GST Value
                    </Checkbox>
                  </Form.Item>

                  {defaultGst && (
                    <Form.Item
                      label={
                        <span
                          style={{
                            fontWeight: 600,
                            color: "#374151",
                            fontSize: 13,
                          }}
                        >
                          Default GST %
                        </span>
                      }
                      name="defaultgstper"
                      style={{ marginBottom: 0 }}
                    >
                      <InputNumber
                        min={0}
                        max={100}
                        style={{ width: "100%", borderRadius: 8, fontSize: 13 }}
                      />
                    </Form.Item>
                  )}
                </div>

                {/* ── Toggles ───────────────────────────── */}
                <div
                  style={{
                    background:
                      "linear-gradient(135deg,#eef2ff 0%,#e0e7ff 100%)",
                    border: "1px solid #c7d2fe",
                    borderRadius: 12,
                    padding: "12px 16px",
                    display: "flex",
                    flexDirection: "column",
                    gap: 10,
                    marginBottom: 14,
                  }}
                >
                  <Form.Item
                    name="effecttopurchases"
                    valuePropName="checked"
                    style={{ marginBottom: 0 }}
                  >
                    <Checkbox
                      style={{ fontWeight: 600, color: INDIGO, fontSize: 13 }}
                    >
                      Effect To Purchases
                    </Checkbox>
                  </Form.Item>
                  <Form.Item
                    name="allowtaans"
                    valuePropName="checked"
                    style={{ marginBottom: 0 }}
                  >
                    <Checkbox
                      style={{ fontWeight: 600, color: INDIGO, fontSize: 13 }}
                    >
                      Allow Taan Entry
                    </Checkbox>
                  </Form.Item>
                </div>

                {/* ── Action Buttons ────────────────────── */}
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={saving}
                    icon={
                      editingKey != null ? (
                        <SaveOutlined />
                      ) : (
                        <PlusCircleOutlined />
                      )
                    }
                    style={{
                      background: `linear-gradient(90deg,${ORANGE} 0%,${AMBER} 100%)`,
                      border: "none",
                      borderRadius: 10,
                      height: 42,
                      fontWeight: 700,
                      fontSize: 13,
                      flex: 1,
                      boxShadow: `0 4px 14px ${ORANGE}44`,
                    }}
                  >
                    {editingKey != null ? "Update" : "Save"}
                  </Button>

                  <Button
                    onClick={handleCancel}
                    icon={<CloseCircleOutlined />}
                    style={{
                      borderRadius: 10,
                      height: 42,
                      fontWeight: 600,
                      border: `1px solid ${ROSE}44`,
                      color: ROSE,
                      background: `${ROSE}08`,
                    }}
                  >
                    Cancel
                  </Button>

                  <Tooltip title="Refresh">
                    <Button
                      icon={<ReloadOutlined />}
                      onClick={handleRefresh}
                      loading={loading}
                      style={{
                        borderRadius: 10,
                        height: 42,
                        border: `1px solid ${TEAL}44`,
                        color: TEAL,
                        background: `${TEAL}08`,
                      }}
                    />
                  </Tooltip>
                </div>
              </Form>
            </div>
          </div>
        </Col>
      </Row>

      <style>{`
        .ptm-row:hover td { background: #fff7ed !important; transition: background 0.15s; }
        .ptm-row-selected td { background: #ffedd5 !important; }
        .ptm-row-selected:hover td { background: #fed7aa !important; }
        .ptm-search::placeholder { color: rgba(255,255,255,0.8); opacity: 1; }
        .ptm-search::-webkit-input-placeholder { color: rgba(255,255,255,0.8); opacity: 1; }
      `}</style>
    </div>
  );
}
